import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { useHoverStyles } from './ResoursesStatus';
import MyIcon from '../../components/MyIcon';

const IconView = ({ title, icon, height, color, onOpen }) => {
  const classes = useHoverStyles();

  return (
    <Paper elevation={2} style={{ height }}>
      <Box
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          onClick={onOpen}
          className={classes.button}
          style={{
            padding: 5,
            overflow: 'hidden',
            objectFit: 'cover',
            cursor: 'pointer',
            borderRadius: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 100,
            height: 100,
            marginTop: 35,
          }}
        >
          <MyIcon size={70} color={color} icon={icon}></MyIcon>
        </Box>

        <Box
          style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            padding: 10,
          }}
        >
          <Typography
            style={{ fontSize: 18, fontWeight: 'bold', marginTop: 20 }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default IconView;
